export function setRemSize() {
  // 获取视口宽度（使用更可靠的window.innerWidth以防ref还没准备好）
  const viewportWidth = window.innerWidth;
  const baseWidth = 375;
  const baseFontSize = 10;
  
  // 计算rem值，使用更灵活的计算方式
  let scale = viewportWidth / baseWidth;
  
  // 设置最大和最小缩放比例，防止字体过大或过小
  const minScale = 0.85;
  const maxScale = 1.2;
  
  scale = Math.max(minScale, Math.min(maxScale, scale));
  // 应用非线性调整，使得在大屏上增长速度变慢
  if (scale > 1) {
    // 当屏幕大于基准宽度时，使用平方根函数减缓增长速度
    scale = 1 + Math.sqrt(scale - 1) * 0.5; // 将系数调整为0.7以减缓增长
  }
  
  const fontSize = baseFontSize * scale;
  
  // 设置HTML根元素的font-size
  document.documentElement.style.fontSize = parseInt(fontSize) + 'px';
  
  // 可以添加调试日志
  console.log(`屏幕宽度1: ${viewportWidth}px, 比例: ${scale}, 字体大小: ${parseInt(fontSize)}px`);

}

export function getEnv() {
  if (typeof window.wx !== 'undefined' && typeof window.wx.miniprogram?.getEnv === 'function') {
    let isMiniProgram = false;
    try {
      // 同步检测小程序环境（微信JS-SDK 1.6.0+支持）
      window.wx.miniprogram.getEnv((res) => {
        isMiniProgram = res.miniprogram;
      });
      if (isMiniProgram) {
        return 'miniprogram';
      }
    } catch (e) {
      // 兼容低版本或异常情况
    }
  }
  if (window.__wxjs_environment === 'miniprogram') return 'miniprogram';
  // if (window.Android) return 'android';
  // if (window.webkit && window.webkit.messageHandlers) return 'ios';
  if (window.parent !== window) return 'web-iframe';
  return 'web';
}